import { useProjektprognosEditingContext } from '../context/ProjektprognosEditingContext'
import { usePeriodReportData } from '../fetchData/queries/usePeriodReportData'
import { Spinner } from '@fluentui/react-components'
import styles from './PeriodReportComparisonInfo.module.css'

const PeriodReportComparisonInfo = () => {
  const { selectedPeriodReport } = useProjektprognosEditingContext()
  const { isLoading } = usePeriodReportData(selectedPeriodReport?.id || null)

  if (!selectedPeriodReport) {
    return null
  }

  // Show loading state while fetching snapshots
  if (isLoading) {
    return (
      <div className={styles.container}>
        <Spinner size="small" label="Laddar snapshots..." />
      </div>
    )
  }

  const { snapshotReferences } = selectedPeriodReport
  const previousSnapshot = snapshotReferences.previousSnapshotReference
  const currentSnapshot =
    snapshotReferences.comparedWithSnapshotReferences?.[
      snapshotReferences.comparedWithSnapshotReferences.length - 1
    ]

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('sv-SE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }

  // If there is no current snapshot, show only previous
  if (!currentSnapshot) {
    return (
      <div className={styles.container}>
        <div className={styles.comparisonRow}>
          <div className={styles.snapshotInfo}>
            <div className={styles.snapshotLabel}>
              {formatDate(previousSnapshot.createdUtc)}
            </div>
          </div>
          <div className={styles.separator}>→</div>
          <div className={styles.snapshotInfo}>
            <div className={styles.snapshotLabel}>Live</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.comparisonRow}>
        <div className={styles.snapshotInfo}>
          <div className={styles.snapshotLabel}>
            {formatDate(previousSnapshot.createdUtc)}
          </div>
        </div>
        <div className={styles.separator}>→</div>
        <div className={styles.snapshotInfo}>
          <div className={styles.snapshotLabel}>
            {formatDate(currentSnapshot.createdUtc)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PeriodReportComparisonInfo
